import { tm } from '../tm'
import { GlobalGoalIcon } from '../GlobalGoal/Icon'
import i18n from './i18n'
import type { CSSProperties } from 'react'
import type { Locales, Project } from '@captaincause/types'

interface ProjectODDsProps {
  project: Project
  className?: string
  style?: CSSProperties
  locale: Locales
}

const emptyObject = {}
export function ProjectODDs({
  project,
  className = '',
  style = emptyObject,
  locale,
}: ProjectODDsProps) {
  if (!project.odds || project.odds.length === 0) return null

  const t = i18n[locale] ?? i18n.fr

  return (
    <div className={tm(className)} style={style}>
      <div className="mb-4 text-dark-gray">{t.title}</div>
      <div className="flex flex-wrap gap-x-10 gap-y-4">
        {project.odds.map(odd => (
          <GlobalGoalIcon key={odd} id={odd} locale={locale} size={94} />
        ))}
      </div>
    </div>
  )
}
